import * as ambassadorWixEcomV1OrdersSettings from './ecom-v1-orders-settings-orders-settings.http.js';
import * as ambassadorWixEcomV1OrdersSettingsTypes from './ecom-v1-orders-settings-orders-settings.types.js';
import * as ambassadorWixEcomV1OrdersSettingsUniversalTypes from './ecom-v1-orders-settings-orders-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getOrdersSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1OrdersSettingsUniversalTypes.GetOrdersSettingsRequest,
  ambassadorWixEcomV1OrdersSettingsTypes.GetOrdersSettingsRequest,
  ambassadorWixEcomV1OrdersSettingsUniversalTypes.GetOrdersSettingsResponse,
  ambassadorWixEcomV1OrdersSettingsTypes.GetOrdersSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1OrdersSettings.getOrdersSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/orders-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateOrdersSettings(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixEcomV1OrdersSettingsUniversalTypes.UpdateOrdersSettingsRequest,
  ambassadorWixEcomV1OrdersSettingsTypes.UpdateOrdersSettingsRequest,
  ambassadorWixEcomV1OrdersSettingsUniversalTypes.UpdateOrdersSettingsResponse,
  ambassadorWixEcomV1OrdersSettingsTypes.UpdateOrdersSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1OrdersSettings.updateOrdersSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/orders-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  OrdersSettings as OrdersSettingsOriginal,
  InventoryUpdateTrigger as InventoryUpdateTriggerOriginal,
  InventoryUpdateTriggerWithLiterals as InventoryUpdateTriggerWithLiteralsOriginal,
  GetOrdersSettingsRequest as GetOrdersSettingsRequestOriginal,
  GetOrdersSettingsResponse as GetOrdersSettingsResponseOriginal,
  UpdateOrdersSettingsRequest as UpdateOrdersSettingsRequestOriginal,
  UpdateOrdersSettingsResponse as UpdateOrdersSettingsResponseOriginal,
  DeleteOrdersSettingsRequest as DeleteOrdersSettingsRequestOriginal,
  DeleteOrdersSettingsResponse as DeleteOrdersSettingsResponseOriginal,
  ListOrdersSettingsRequest as ListOrdersSettingsRequestOriginal,
  ListOrdersSettingsResponse as ListOrdersSettingsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './ecom-v1-orders-settings-orders-settings.types.js';
